import React from "react";
import { Grid, Button, Typography } from "@mui/material";

interface SkipStepButtonProps {
  onSkip: () => void;
  buttonText?: string;
  helperText?: string;
  disabled?: boolean;
}

const SkipStepButton: React.FC<SkipStepButtonProps> = ({
  onSkip,
  buttonText = "Configurar más tarde",
  helperText = "Podrás agregar operadores logísticos desde Configuración",
  disabled = false,
}) => {
  return (
    <Grid item xs={12} sx={{ mt: 2, textAlign: "center" }}>
      <Button
        variant="text"
        onClick={onSkip}
        color="inherit"
        disabled={disabled}
        sx={{
          textDecoration: "underline",
          color: "text.secondary",
          "&:hover": {
            textDecoration: "underline",
            backgroundColor: "transparent",
          },
        }}
      >
        {buttonText}
      </Button>
      <Typography
        variant="caption"
        display="block"
        color="text.secondary"
        sx={{ mt: 0.5 }}
      >
        {helperText}
      </Typography>
    </Grid>
  );
};

export default SkipStepButton;
